import React, { useEffect, useState } from 'react';
import TeamTile                       from './TeamTile'
import TeamTileIndicators             from './TeamTileIndicators'
import staff                          from 'pursuit/config/staff';
import useInterval                    from 'utilities/useInterval'

export default function OurTeam(props) {
    const [tiles, setTiles] = useState([]);
    const [activeTile, setActiveTile] = useState(0);
    const interval = Number(props.interval) * 1000 || 8000;

    useEffect(() => {
        const homepageTiles = Object.keys(staff).filter(item => {
            if (staff[item].onHomePage === true) {
                return staff[item];
            }

            return false
        });

        setTiles(homepageTiles);
    }, []);

    useInterval(() => {
        setNextTile();
    }, interval)

    const setNextTile = () => {
        let tile = Number(activeTile) + 1;

        if (tile > Object.keys(tiles).length - 1) {
            tile = 0;
        }

        setActiveTile(tile);
    }

    return (
        <div role="home-our-team" className="justify-center content-maxWidth">
            <article role="content" className="justify-center">
                <div className="content-subTitle">How Can We Help</div>
                <h2 className="content-mainTitle minor-margin--bottom">Our Team</h2>

                <div className="grid-center-noGutter">
                    <div className="col-11 tile-container">
                        {tiles.map((slug, key) => {
                            var item = staff[slug];

                            if (item.onHomePage === false) {
                                return null;
                            }

                            return (
                                <TeamTile
                                    key={key}
                                    fullName={item.fullName}
                                    firstName={item.firstName}
                                    slug={item.slug}
                                    letters={item.letters}
                                    profession={item.mainDiscipline}
                                    bio={item.miniBio}
                                    active={key === activeTile}
                                />
                            )
                        })}
                    </div>
                </div>
            </article>
            <TeamTileIndicators
                team={tiles}
                activeTile={activeTile}
                onClick={setActiveTile}
            />
        </div>
    );
}
